import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import 'rxjs/add/operator/map';

@Injectable()
export class CountriesService {
  url:string = GLOBAL.url+"countries";

  constructor( private http:HttpClient ) {}

  public get(){
    return this.http.get(this.url+"?sort=+name" ).map( res => {
        return res;
    });
  }

  public getAll(){
    let url = this.url+'?limit=250';
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public save(prov:any){
    return this.http.post(this.url, prov)
      .map( data => {
        return data;
      });
  }

  public update(url:string, body){

    return this.http.put(url, body)
      .map( data => {
        return data;
      });
  }

  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/countries.service.ts